import ConfirmPoptip from './confirm-poptip';

export default ConfirmPoptip;
